import { IAircraft, IAircraftType } from "@cai-services";

export class Aircraft implements IAircraft {
  aircraftName: string;
  aircraftCode: string;
  capacity: number;
  volumeCapacity: number;
  aircraftType: IAircraftType;

  constructor (aircraftCode?: string, capacity?: number, aircraftName?: string) {
    this.aircraftCode = aircraftCode;
    this.capacity = capacity;
    this.aircraftName = aircraftName;
  }
}
